/**
 * Box shadows for use to express elevation, following the SKAPA guidelines.
 */
export var ElevationEnum;
(function (ElevationEnum) {
    ElevationEnum["SkapaDefaultElevationShadow"] = "rgba(0, 0, 0, 0.1) 0px 0px 16px 0px;";
    ElevationEnum["UpwardElevationShadow"] = "rgba(0, 0, 0, 0.1) 0px -10px 16px 0px;";
})(ElevationEnum || (ElevationEnum = {}));
//# sourceMappingURL=elevations.js.map